import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-427e96a8")

_pushScopeId("data-v-427e96a8")
const _hoisted_1 = { class: "create-form-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_4 = { class: "head-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "form-header"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Back")
const _hoisted_8 = { class: "heading" }
const _hoisted_9 = {
  key: 0,
  class: "heading"
}
const _hoisted_10 = { class: "explore-templates" }
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-exclamation-circle mr-1",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" }),
  /*#__PURE__*/_createVNode("path", { d: "M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Tired of creating form from scratch? We've made it easy for you. Explore from existing templates ")
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-right" }, null, -1)
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "create form", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Create form using form elements.", -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "edit form", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Edit form using form elements.", -1)
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "send form", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Send form with the form elements.", -1)
const _hoisted_26 = { class: "col-sm-6" }
const _hoisted_27 = { class: "text-sm-right mb-2" }
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Preview")
const _hoisted_30 = { class: "form-wrap pt-0" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", { for: "" }, "Title of form", -1)
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { for: "" }, "Description", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("h5", { class: "dim-heading" }, "Customize form elements", -1)
const _hoisted_36 = {
  key: 1,
  class: "form-elements",
  id: "customizeFormElements"
}
const _hoisted_37 = { class: "form-wrap pt-0" }
const _hoisted_38 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  key: 0,
  class: "row"
}
const _hoisted_41 = { class: "col-lg-6" }
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = { class: "col-lg-3" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = { class: "col-lg-3" }
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_54 = {
  key: 1,
  class: "row"
}
const _hoisted_55 = { class: "col-lg-8" }
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = { class: "col-lg-4" }
const _hoisted_58 = { class: "form-group" }
const _hoisted_59 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_66 = { class: "col-lg-1" }
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = {
  key: 0,
  class: "col-lg-9"
}
const _hoisted_69 = { class: "form-group" }
const _hoisted_70 = {
  key: 1,
  class: "col-lg-9"
}
const _hoisted_71 = { class: "form-group" }
const _hoisted_72 = { class: "col-lg-2" }
const _hoisted_73 = { class: "action-btn" }
const _hoisted_74 = /*#__PURE__*/_createVNode("svg", {
  class: "svg-inline--fa fa-times fa-w-11",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "times",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 352 512",
  "data-fa-i2svg": ""
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
  })
], -1)
const _hoisted_75 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_76 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_78 = { class: "form-element-action" }
const _hoisted_79 = { class: "custom-control custom-switch mr-3" }
const _hoisted_80 = { class: "action-wrapper" }
const _hoisted_81 = /*#__PURE__*/_createVNode("i", { class: "far fa-clone" }, null, -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Duplicate ", -1)
const _hoisted_83 = { class: "action-wrapper" }
const _hoisted_84 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" }, null, -1)
const _hoisted_85 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Delete ", -1)
const _hoisted_86 = { class: "action-wrapper" }
const _hoisted_87 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Add form New element ", -1)
const _hoisted_89 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { class: "list-items-row" }
const _hoisted_92 = { for: "checkddd" }
const _hoisted_93 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_94 = { key: 0 }
const _hoisted_95 = {
  key: 0,
  class: "row"
}
const _hoisted_96 = { class: "col-lg-6" }
const _hoisted_97 = { class: "form-group" }
const _hoisted_98 = { class: "col-lg-3" }
const _hoisted_99 = { class: "form-group" }
const _hoisted_100 = { class: "col-lg-3" }
const _hoisted_101 = { class: "form-group" }
const _hoisted_102 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_109 = {
  key: 1,
  class: "row"
}
const _hoisted_110 = { class: "col-lg-8" }
const _hoisted_111 = { class: "form-group" }
const _hoisted_112 = { class: "col-lg-4" }
const _hoisted_113 = { class: "form-group" }
const _hoisted_114 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_121 = { class: "col-lg-1" }
const _hoisted_122 = { class: "form-group" }
const _hoisted_123 = {
  key: 0,
  class: "col-lg-9"
}
const _hoisted_124 = { class: "form-group" }
const _hoisted_125 = {
  key: 1,
  class: "col-lg-9"
}
const _hoisted_126 = { class: "form-group" }
const _hoisted_127 = { class: "col-lg-2" }
const _hoisted_128 = /*#__PURE__*/_createVNode("svg", {
  class: "svg-inline--fa fa-times fa-w-11",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "times",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 352 512",
  "data-fa-i2svg": ""
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
  })
], -1)
const _hoisted_129 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_130 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_131 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_132 = { class: "form-element-action" }
const _hoisted_133 = { class: "custom-control custom-switch mr-3" }
const _hoisted_134 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-clone" })
], -1)
const _hoisted_135 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Duplicate ", -1)
const _hoisted_136 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" })
], -1)
const _hoisted_137 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Delete ", -1)
const _hoisted_138 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn add-element-btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_139 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Add form New element ", -1)
const _hoisted_140 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_141 = { key: 1 }
const _hoisted_142 = { class: "list-items" }
const _hoisted_143 = { for: "checkddd" }
const _hoisted_144 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_145 = { key: 0 }
const _hoisted_146 = {
  key: 0,
  class: "row"
}
const _hoisted_147 = { class: "col-lg-6" }
const _hoisted_148 = { class: "form-group" }
const _hoisted_149 = { class: "col-lg-3" }
const _hoisted_150 = { class: "form-group" }
const _hoisted_151 = { class: "col-lg-3" }
const _hoisted_152 = { class: "form-group" }
const _hoisted_153 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_160 = {
  key: 1,
  class: "row"
}
const _hoisted_161 = { class: "col-lg-8" }
const _hoisted_162 = { class: "form-group" }
const _hoisted_163 = { class: "col-lg-4" }
const _hoisted_164 = { class: "form-group" }
const _hoisted_165 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_172 = { class: "col-lg-1" }
const _hoisted_173 = { class: "form-group" }
const _hoisted_174 = {
  key: 0,
  class: "col-lg-9"
}
const _hoisted_175 = { class: "form-group" }
const _hoisted_176 = {
  key: 1,
  class: "col-lg-9"
}
const _hoisted_177 = { class: "form-group" }
const _hoisted_178 = { class: "col-lg-2" }
const _hoisted_179 = /*#__PURE__*/_createVNode("svg", {
  class: "svg-inline--fa fa-times fa-w-11",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "times",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 352 512",
  "data-fa-i2svg": ""
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
  })
], -1)
const _hoisted_180 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_181 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_182 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_183 = { class: "form-element-action" }
const _hoisted_184 = { class: "custom-control custom-switch mr-3" }
const _hoisted_185 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-clone" })
], -1)
const _hoisted_186 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Duplicate ", -1)
const _hoisted_187 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" })
], -1)
const _hoisted_188 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Delete ", -1)
const _hoisted_189 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn add-element-btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_190 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Add form New element ", -1)
const _hoisted_191 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_192 = { key: 1 }
const _hoisted_193 = { class: "block-list" }
const _hoisted_194 = {
  key: 3,
  class: "mb-0"
}
const _hoisted_195 = { key: 0 }
const _hoisted_196 = {
  key: 0,
  class: "row"
}
const _hoisted_197 = { class: "col-lg-6" }
const _hoisted_198 = { class: "form-group" }
const _hoisted_199 = { class: "col-lg-3" }
const _hoisted_200 = { class: "form-group" }
const _hoisted_201 = { class: "col-lg-3" }
const _hoisted_202 = { class: "form-group" }
const _hoisted_203 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_210 = {
  key: 1,
  class: "row"
}
const _hoisted_211 = { class: "col-lg-6" }
const _hoisted_212 = { class: "form-group" }
const _hoisted_213 = { class: "col-lg-3" }
const _hoisted_214 = { class: "form-group" }
const _hoisted_215 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_222 = { class: "form-group" }
const _hoisted_223 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_224 = { class: "form-element-action" }
const _hoisted_225 = { class: "custom-control custom-switch mr-3" }
const _hoisted_226 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-clone" })
], -1)
const _hoisted_227 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Duplicate ", -1)
const _hoisted_228 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" })
], -1)
const _hoisted_229 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Delete ", -1)
const _hoisted_230 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn add-element-btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_231 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Add form New element ", -1)
const _hoisted_232 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_233 = { key: 1 }
const _hoisted_234 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_235 = {
  key: 4,
  class: "mb-0"
}
const _hoisted_236 = { key: 0 }
const _hoisted_237 = {
  key: 0,
  class: "row"
}
const _hoisted_238 = { class: "col-lg-6" }
const _hoisted_239 = { class: "form-group" }
const _hoisted_240 = {
  key: 0,
  class: "col-lg-3"
}
const _hoisted_241 = { class: "form-group" }
const _hoisted_242 = { class: "col-lg-3" }
const _hoisted_243 = { class: "form-group" }
const _hoisted_244 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_251 = {
  key: 1,
  class: "row"
}
const _hoisted_252 = { class: "col-lg-8" }
const _hoisted_253 = { class: "form-group" }
const _hoisted_254 = { class: "col-lg-4" }
const _hoisted_255 = { class: "form-group" }
const _hoisted_256 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_263 = { class: "form-group" }
const _hoisted_264 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_265 = { class: "form-element-action" }
const _hoisted_266 = {
  class: "custom-control custom-switch mr-3",
  id: "formElementRequired"
}
const _hoisted_267 = /*#__PURE__*/_createVNode("a", {
  id: "duplicateSelectedElementRow",
  href: "javascript:void(0)",
  class: "btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-clone" })
], -1)
const _hoisted_268 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Duplicate ", -1)
const _hoisted_269 = /*#__PURE__*/_createVNode("a", {
  id: "deleteSelectedElementRow",
  href: "javascript:void(0)",
  class: "btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" })
], -1)
const _hoisted_270 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Delete ", -1)
const _hoisted_271 = /*#__PURE__*/_createVNode("a", {
  id: "addNewElementRow",
  href: "javascript:void(0)",
  class: "btn add-element-btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_272 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Add form New element ", -1)
const _hoisted_273 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_274 = { key: 1 }
const _hoisted_275 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_276 = {
  key: 5,
  class: "mb-0"
}
const _hoisted_277 = { key: 0 }
const _hoisted_278 = {
  key: 0,
  class: "row"
}
const _hoisted_279 = { class: "col-lg-6" }
const _hoisted_280 = { class: "form-group" }
const _hoisted_281 = { class: "col-lg-3" }
const _hoisted_282 = { class: "form-group" }
const _hoisted_283 = { class: "col-lg-3" }
const _hoisted_284 = { class: "form-group" }
const _hoisted_285 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_292 = {
  key: 1,
  class: "row"
}
const _hoisted_293 = { class: "col-lg-8" }
const _hoisted_294 = { class: "form-group" }
const _hoisted_295 = { class: "col-lg-4" }
const _hoisted_296 = { class: "form-group" }
const _hoisted_297 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_304 = { class: "row" }
const _hoisted_305 = { class: "col-lg-9" }
const _hoisted_306 = { class: "canvas-wrap" }
const _hoisted_307 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_308 = { class: "form-element-action" }
const _hoisted_309 = { class: "custom-control custom-switch mr-3" }
const _hoisted_310 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-clone" })
], -1)
const _hoisted_311 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Duplicate ", -1)
const _hoisted_312 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" })
], -1)
const _hoisted_313 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Delete ", -1)
const _hoisted_314 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn add-element-btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_315 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Add form New element ", -1)
const _hoisted_316 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_317 = { key: 1 }
const _hoisted_318 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_319 = {
  key: 6,
  class: "mb-0"
}
const _hoisted_320 = { key: 0 }
const _hoisted_321 = {
  key: 0,
  class: "row"
}
const _hoisted_322 = { class: "col-lg-6" }
const _hoisted_323 = { class: "form-group" }
const _hoisted_324 = {
  key: 0,
  class: "col-lg-3"
}
const _hoisted_325 = { class: "form-group" }
const _hoisted_326 = { class: "col-lg-3" }
const _hoisted_327 = { class: "form-group" }
const _hoisted_328 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_335 = {
  key: 1,
  class: "row"
}
const _hoisted_336 = { class: "col-lg-8" }
const _hoisted_337 = { class: "form-group" }
const _hoisted_338 = { class: "col-lg-4" }
const _hoisted_339 = { class: "form-group" }
const _hoisted_340 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\" data-v-427e96a8>Checkbox</option><option value=\"radioButton\" data-v-427e96a8>Radio</option><option value=\"single_select\" data-v-427e96a8>Select</option><option value=\"textArea\" data-v-427e96a8>Textarea</option><option value=\"textbox\" data-v-427e96a8>TextBox</option><option value=\"datePicker\" data-v-427e96a8>DatePicker</option><option value=\"digitalSignature\" data-v-427e96a8>Signature Pad</option>", 7)
const _hoisted_347 = { class: "row" }
const _hoisted_348 = { class: "col-lg-12" }
const _hoisted_349 = { class: "input-group mb-2 mr-sm-2" }
const _hoisted_350 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createVNode("i", { class: "far fa-calendar" })
  ])
], -1)
const _hoisted_351 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_352 = { class: "form-element-action" }
const _hoisted_353 = { class: "custom-control custom-switch mr-3" }
const _hoisted_354 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-clone" })
], -1)
const _hoisted_355 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Duplicate ", -1)
const _hoisted_356 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" })
], -1)
const _hoisted_357 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Delete ", -1)
const _hoisted_358 = /*#__PURE__*/_createVNode("a", {
  href: "javascript:void(0)",
  class: "btn add-element-btn"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_359 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Add form New element ", -1)
const _hoisted_360 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_361 = { key: 1 }
const _hoisted_362 = { class: "input-group mb-2 mr-sm-2" }
const _hoisted_363 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createVNode("i", { class: "far fa-calendar" })
  ])
], -1)
const _hoisted_364 = { class: "text-right" }
const _hoisted_365 = { class: "modal-wrap default-modal" }
const _hoisted_366 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "sendoption",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_367 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_368 = { class: "modal-content" }
const _hoisted_369 = { class: "modal-header" }
const _hoisted_370 = /*#__PURE__*/_createVNode("svg", {
  class: "svg-inline--fa fa-chevron-left fa-w-10",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "chevron-left",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512",
  "data-fa-i2svg": ""
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
  })
], -1)
const _hoisted_371 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Send Option")
], -1)
const _hoisted_372 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_373 = { class: "modal-body" }
const _hoisted_374 = { class: "form-group" }
const _hoisted_375 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Select Form Type", -1)
const _hoisted_376 = { class: "form-group" }
const _hoisted_377 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Select Form Tag", -1)
const _hoisted_378 = /*#__PURE__*/_createVNode("div", { class: "send-option-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-share" })
], -1)
const _hoisted_379 = /*#__PURE__*/_createVNode("h5", null, "Save and send to user", -1)
const _hoisted_380 = /*#__PURE__*/_createVNode("p", null, "You can save and send this form right now.", -1)
const _hoisted_381 = /*#__PURE__*/_createVNode("div", { class: "next" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-right" })
], -1)
const _hoisted_382 = { key: 1 }
const _hoisted_383 = { class: "form-group" }
const _hoisted_384 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Select project 22", -1)
const _hoisted_385 = { class: "form-group" }
const _hoisted_386 = {
  key: 0,
  class: "form-header p-0"
}
const _hoisted_387 = {
  key: 1,
  for: "exampleInputEmail1"
}
const _hoisted_388 = { class: "form-group" }
const _hoisted_389 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Choose member", -1)
const _hoisted_390 = { class: "mb-0" }
const _hoisted_391 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_392 = { class: "form-group" }
const _hoisted_393 = /*#__PURE__*/_createVNode("label", { for: "" }, "Additional Message", -1)
const _hoisted_394 = {
  key: 2,
  class: "send-option-list"
}
const _hoisted_395 = { key: 0 }
const _hoisted_396 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_397 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_398 = { class: "modal-footer d-block" }
const _hoisted_399 = { class: "row align-items-end no-gutters" }
const _hoisted_400 = {
  key: 0,
  class: "col-lg-6"
}
const _hoisted_401 = { class: "share-form-block form-inline" }
const _hoisted_402 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "mb-1 mr-2"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock mb-1 mr-2" }),
  /*#__PURE__*/_createTextVNode(" Share this Form : ")
], -1)
const _hoisted_403 = {
  key: 0,
  class: "form-wrap pt-0"
}
const _hoisted_404 = { class: "tooltip-block" }
const _hoisted_405 = /*#__PURE__*/_createVNode("i", { class: "far fa-question-circle ml-2" }, null, -1)
const _hoisted_406 = { class: "tooltip-msg" }
const _hoisted_407 = { class: "mb-0" }
const _hoisted_408 = { class: "col-lg-6" }
const _hoisted_409 = { class: "col-button" }
const _hoisted_410 = { class: "modal-wrap default-modal" }
const _hoisted_411 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "selectproject",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_412 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_413 = { class: "modal-content" }
const _hoisted_414 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\" data-v-427e96a8><div data-v-427e96a8><h5 class=\"modal-title\" id=\"exampleModalLabel\" data-v-427e96a8> Select project </h5><p class=\"text-muted\" data-v-427e96a8> You will be creating form for this project </p></div><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" data-v-427e96a8><span aria-hidden=\"true\" data-v-427e96a8>×</span></button></div>", 1)
const _hoisted_415 = { class: "modal-body" }
const _hoisted_416 = { class: "form-wrap pt-0" }
const _hoisted_417 = { class: "form-group" }
const _hoisted_418 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Select project", -1)
const _hoisted_419 = { class: "modal-footer" }
const _hoisted_420 = { class: "modal-wrap default-modal" }
const _hoisted_421 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "showCreatedForm",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_422 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_423 = { class: "modal-content" }
const _hoisted_424 = { class: "modal-header" }
const _hoisted_425 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Preview")
], -1)
const _hoisted_426 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_427 = { class: "modal-body" }
const _hoisted_428 = { class: "form-wrap pt-0" }
const _hoisted_429 = { class: "preview-title" }
const _hoisted_430 = /*#__PURE__*/_createVNode("label", { for: "" }, "Project info", -1)
const _hoisted_431 = { key: 0 }
const _hoisted_432 = { key: 1 }
const _hoisted_433 = { class: "preview-form" }
const _hoisted_434 = {
  key: 0,
  disabled: ""
}
const _hoisted_435 = { class: "form-wrap pt-4" }
const _hoisted_436 = { key: 6 }
const _hoisted_437 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_438 = { key: 7 }
const _hoisted_439 = { class: "row" }
const _hoisted_440 = { class: "col-md-2" }
const _hoisted_441 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-signature fa-3x" })
], -1)
const _hoisted_442 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_443 = { class: "modal-wrap xl-size" }
const _hoisted_444 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "templateModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_445 = { class: "modal-dialog" }
const _hoisted_446 = { class: "modal-content" }
const _hoisted_447 = { class: "modal-header" }
const _hoisted_448 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, " Choose Documents ", -1)
const _hoisted_449 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_450 = { class: "modal-body" }
const _hoisted_451 = {
  key: 0,
  class: "loader-text-wrap"
}
const _hoisted_452 = /*#__PURE__*/_createTextVNode(" Loading ")
const _hoisted_453 = /*#__PURE__*/_createVNode("span", { class: "lds-ellipsis-black" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createVNode("span")
], -1)
const _hoisted_454 = {
  key: 1,
  class: "row"
}
const _hoisted_455 = { class: "form-name" }
const _hoisted_456 = { class: "doc-wrap my-2" }
const _hoisted_457 = { class: "hover-wrap" }
const _hoisted_458 = { class: "hover-items" }
const _hoisted_459 = {
  key: 1,
  src: "https://www.brokenarrowwear.com/img/designer/template-fitness.png"
}
const _hoisted_460 = {
  key: 2,
  class: "card"
}
const _hoisted_461 = { class: "modal-footer" }
const _hoisted_462 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_463 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "successfulModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_464 = { class: "modal-dialog" }
const _hoisted_465 = { class: "modal-content" }
const _hoisted_466 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Successful !!!")
], -1)
const _hoisted_467 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "alert alert-success text-center",
    role: "alert"
  }, " Created form Successfully. ")
], -1)
const _hoisted_468 = { class: "modal-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_TitleComponent = _resolveComponent("TitleComponent")
  const _component_TextBoxComponent = _resolveComponent("TextBoxComponent")
  const _component_RadioButtonComponent = _resolveComponent("RadioButtonComponent")
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_CheckBox = _resolveComponent("CheckBox")
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_EmptyData = _resolveComponent("EmptyData")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (
          _ctx.state.ui.isPostLoading.edocDataMapping ||
          _ctx.state.ui.isPostLoading.edocMapped ||_ctx.state.ui.isPostLoading.formMessage||_ctx.state.ui.isPostLoading.createFormTemplate
        )
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        (
            _ctx.state.data.selectedChannelByProject.project &&
            _ctx.state.data.selectedChannelByProject.project.name
          )
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", null, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "text-muted",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sendBack && _ctx.sendBack(...args)))
                }, [
                  _hoisted_6,
                  _hoisted_7
                ])
              ]),
              _createVNode("h1", _hoisted_8, " Project : " + _toDisplayString(_ctx.state.data.selectedChannelByProject.project.name), 1),
              (
              _ctx.state.data.selectedChannelByProject.channel &&
              _ctx.state.data.selectedChannelByProject.channel.name
            )
                ? (_openBlock(), _createBlock("h2", _hoisted_9, " Channel : " + _toDisplayString(_ctx.state.data.selectedChannelByProject.channel.name), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_10, [
          _createVNode("a", {
            href: "javascript:void(0)",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToTemplateSearch && _ctx.redirectToTemplateSearch(...args)))
          }, [
            _hoisted_11,
            _hoisted_12,
            _hoisted_13
          ])
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.state.ui.errorList,
          hasError: _ctx.state.ui.hasErrorStatus
        }, null, 8, ["errors", "hasError"]),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            (_ctx.formStatus === 'Create Mode')
              ? (_openBlock(), _createBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _hoisted_19
                ]))
              : _createCommentVNode("", true),
            (_ctx.formStatus === 'Edit Mode')
              ? (_openBlock(), _createBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _hoisted_22
                ]))
              : _createCommentVNode("", true),
            (_ctx.formStatus === 'Send Mode')
              ? (_openBlock(), _createBlock("div", _hoisted_23, [
                  _hoisted_24,
                  _hoisted_25
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_26, [
            _createVNode("div", _hoisted_27, [
              _createVNode("a", {
                id: "previewNewForm",
                href: "javascript:void(0)",
                class: "btn default-btn outline",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkFormData && _ctx.checkFormData(...args)))
              }, [
                _hoisted_28,
                _hoisted_29
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_30, [
          _createVNode(_component_ErrorList, {
            errors: _ctx.state.ui.validationList,
            hasError: _ctx.state.ui.hasErrorStatus
          }, null, 8, ["errors", "hasError"]),
          _createVNode("div", _hoisted_31, [
            _hoisted_32,
            _withDirectives(_createVNode("input", {
              id: "titleOfForm",
              type: "text",
              class: 
                _ctx.state.newFormData.titleError
                  ? 'form-control error-field'
                  : 'form-control'
              ,
              placeholder: "Untitled form",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.newFormData.title = $event))
            }, null, 2), [
              [_vModelText, _ctx.state.newFormData.title]
            ])
          ]),
          _createVNode("div", _hoisted_33, [
            _hoisted_34,
            _withDirectives(_createVNode("input", {
              id: "descriptionOfForm",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.newFormData.description = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Form description"
            }, null, 512), [
              [_vModelText, _ctx.state.newFormData.description]
            ])
          ])
        ])
      ]),
      _hoisted_35,
      (_ctx.dynamicForm && _ctx.dynamicForm.length)
        ? (_openBlock(), _createBlock("div", _hoisted_36, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dynamicForm, (form, formIndex) => {
              return (_openBlock(), _createBlock("div", {
                class: 
            _ctx.state.data.activeElementIndex === formIndex
              ? 'card active-card clickable-card'
              : 'card'
          ,
                key: formIndex
              }, [
                _createVNode("div", _hoisted_37, [
                  (form.type === 'checkBox')
                    ? (_openBlock(), _createBlock("div", _hoisted_38, [
                        (form.isActive)
                          ? (_openBlock(), _createBlock("div", _hoisted_39, [
                              (form.metaDataList && form.metaDataList.length)
                                ? (_openBlock(), _createBlock("div", _hoisted_40, [
                                    _createVNode("div", _hoisted_41, [
                                      _createVNode("div", _hoisted_42, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_43, [
                                      _createVNode("div", _hoisted_44, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.metaData = $event),
                                          onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.selectMetaData && _ctx.selectMetaData(...args)))
                                        }, [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.metaDataList, (metaData, metaDataIndex) => {
                                            return (_openBlock(), _createBlock("option", {
                                              value: metaData,
                                              key: metaDataIndex
                                            }, _toDisplayString(metaData), 9, ["value"]))
                                          }), 128))
                                        ], 40, ["onUpdate:modelValue"]), [
                                          [_vModelSelect, form.metaData]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_45, [
                                      _createVNode("div", _hoisted_46, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_47
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_54, [
                                    _createVNode("div", _hoisted_55, [
                                      _createVNode("div", _hoisted_56, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_57, [
                                      _createVNode("div", _hoisted_58, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_59
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ])),
                              _createVNode("div", {
                                class: "form-group",
                                onClick: ($event: any) => (_ctx.changeActiveStatus(form))
                              }, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.options, (options, optionsIndex) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "row checkbox",
                                    key: optionsIndex
                                  }, [
                                    _createVNode("div", _hoisted_66, [
                                      _createVNode("div", _hoisted_67, [
                                        _withDirectives(_createVNode("input", {
                                          type: "checkbox",
                                          id: "checkbox",
                                          name: "checkbox1",
                                          "onUpdate:modelValue": ($event: any) => (options.selected = $event),
                                          value: options.option
                                        }, null, 8, ["onUpdate:modelValue", "value"]), [
                                          [_vModelCheckbox, options.selected]
                                        ])
                                      ])
                                    ]),
                                    (
                        form.metaDataList &&
                        form.metaDataList.length &&
                        optionsIndex === 0
                      )
                                      ? (_openBlock(), _createBlock("div", _hoisted_68, [
                                          _createVNode("div", _hoisted_69, [
                                            _withDirectives(_createVNode("input", {
                                              type: "text",
                                              class: 
                            options.optionError
                              ? 'form-control error-field'
                              : 'form-control'
                          ,
                                              placeholder: `Option ${optionsIndex + 1}`,
                                              "onUpdate:modelValue": ($event: any) => (options.option = $event)
                                            }, null, 10, ["placeholder", "onUpdate:modelValue"]), [
                                              [_vModelText, options.option]
                                            ])
                                          ])
                                        ]))
                                      : (_openBlock(), _createBlock("div", _hoisted_70, [
                                          _createVNode("div", _hoisted_71, [
                                            _withDirectives(_createVNode("input", {
                                              type: "text",
                                              class: 
                            options.optionError
                              ? 'form-control error-field'
                              : 'form-control'
                          ,
                                              placeholder: `Option ${optionsIndex + 1}`,
                                              "onUpdate:modelValue": ($event: any) => (options.option = $event)
                                            }, null, 10, ["placeholder", "onUpdate:modelValue"]), [
                                              [_vModelText, options.option]
                                            ])
                                          ])
                                        ])),
                                    _createVNode("div", _hoisted_72, [
                                      _createVNode("div", _hoisted_73, [
                                        _createVNode("button", {
                                          type: "button",
                                          class: "option-btn",
                                          onClick: ($event: any) => (_ctx.deleteSelecedOption(form, options))
                                        }, [
                                          _hoisted_74
                                        ], 8, ["onClick"]),
                                        (form.options && form.options.length)
                                          ? (_openBlock(), _createBlock("span", _hoisted_75, [
                                              (optionsIndex === form.options.length - 1)
                                                ? (_openBlock(), _createBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: "add-btn",
                                                    onClick: ($event: any) => (_ctx.addSelectOptions(form))
                                                  }, [
                                                    _hoisted_76
                                                  ], 8, ["onClick"]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ], 8, ["onClick"]),
                              _hoisted_77,
                              _createVNode("div", _hoisted_78, [
                                _createVNode("div", _hoisted_79, [
                                  _withDirectives(_createVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: `customSwitch${formIndex}`,
                                    "onUpdate:modelValue": ($event: any) => (form.required = $event)
                                  }, null, 8, ["id", "onUpdate:modelValue"]), [
                                    [_vModelCheckbox, form.required]
                                  ]),
                                  _createVNode("label", {
                                    class: "custom-control-label",
                                    for: `customSwitch${formIndex}`
                                  }, "Required", 8, ["for"])
                                ]),
                                _createVNode("div", _hoisted_80, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "btn",
                                    onClick: ($event: any) => (_ctx.duplicateSelectedElement(form))
                                  }, [
                                    _hoisted_81
                                  ], 8, ["onClick"]),
                                  _hoisted_82
                                ]),
                                _createVNode("div", _hoisted_83, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "btn",
                                    onClick: ($event: any) => (_ctx.deleteSelectedElement(form))
                                  }, [
                                    _hoisted_84
                                  ], 8, ["onClick"]),
                                  _hoisted_85
                                ]),
                                _createVNode("div", _hoisted_86, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "btn add-element-btn",
                                    onClick: ($event: any) => (_ctx.addElementNew(form))
                                  }, [
                                    _hoisted_87
                                  ], 8, ["onClick"]),
                                  _hoisted_88
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: "readonly checkbox-design",
                              onClick: ($event: any) => (_ctx.changeActiveStatus(form))
                            }, [
                              (form.title)
                                ? (_openBlock(), _createBlock("label", _hoisted_89, _toDisplayString(form.title), 1))
                                : (_openBlock(), _createBlock("label", _hoisted_90, "Question")),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.options, (options, optionsIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "list-items",
                                  key: optionsIndex
                                }, [
                                  _createVNode("div", _hoisted_91, [
                                    _withDirectives(_createVNode("input", {
                                      type: "checkbox",
                                      id: "",
                                      name: "checkddd",
                                      value: options.option,
                                      "onUpdate:modelValue": ($event: any) => (options.selected = $event)
                                    }, null, 8, ["value", "onUpdate:modelValue"]), [
                                      [_vModelCheckbox, options.selected]
                                    ]),
                                    _createVNode("label", _hoisted_92, _toDisplayString(options.option), 1)
                                  ])
                                ]))
                              }), 128))
                            ], 8, ["onClick"]))
                      ]))
                    : _createCommentVNode("", true),
                  (form.type === 'radioButton')
                    ? (_openBlock(), _createBlock("div", _hoisted_93, [
                        (form.isActive)
                          ? (_openBlock(), _createBlock("div", _hoisted_94, [
                              (form.metaDataList && form.metaDataList.length)
                                ? (_openBlock(), _createBlock("div", _hoisted_95, [
                                    _createVNode("div", _hoisted_96, [
                                      _createVNode("div", _hoisted_97, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_98, [
                                      _createVNode("div", _hoisted_99, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.metaData = $event),
                                          onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.selectMetaData && _ctx.selectMetaData(...args)))
                                        }, [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.metaDataList, (metaData, metaDataIndex) => {
                                            return (_openBlock(), _createBlock("option", {
                                              value: metaData,
                                              key: metaDataIndex
                                            }, _toDisplayString(metaData), 9, ["value"]))
                                          }), 128))
                                        ], 40, ["onUpdate:modelValue"]), [
                                          [_vModelSelect, form.metaData]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_100, [
                                      _createVNode("div", _hoisted_101, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_102
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_109, [
                                    _createVNode("div", _hoisted_110, [
                                      _createVNode("div", _hoisted_111, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_112, [
                                      _createVNode("div", _hoisted_113, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_114
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ])),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.options, (options, optionsIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "row checkbox",
                                  key: optionsIndex
                                }, [
                                  _createVNode("div", _hoisted_121, [
                                    _createVNode("div", _hoisted_122, [
                                      _withDirectives(_createVNode("input", {
                                        type: "radio",
                                        id: `radioButton${optionsIndex}`,
                                        name: `radioButton${optionsIndex}`,
                                        "onUpdate:modelValue": ($event: any) => (options.selected = $event),
                                        value: options.option
                                      }, null, 8, ["id", "name", "onUpdate:modelValue", "value"]), [
                                        [_vModelRadio, options.selected]
                                      ])
                                    ])
                                  ]),
                                  (form.metaDataList && form.metaDataList.length)
                                    ? (_openBlock(), _createBlock("div", _hoisted_123, [
                                        _createVNode("div", _hoisted_124, [
                                          _withDirectives(_createVNode("input", {
                                            id: `radioButton${optionsIndex}`,
                                            name: `radioButton${optionsIndex}`,
                                            type: "text",
                                            class: 
                          options.optionError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                            placeholder: `Option ${optionsIndex + 1}`,
                                            "onUpdate:modelValue": ($event: any) => (options.option = $event)
                                          }, null, 10, ["id", "name", "placeholder", "onUpdate:modelValue"]), [
                                            [_vModelText, options.option]
                                          ])
                                        ])
                                      ]))
                                    : (_openBlock(), _createBlock("div", _hoisted_125, [
                                        _createVNode("div", _hoisted_126, [
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            class: 
                          options.optionError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                            placeholder: `Option ${optionsIndex + 1}`,
                                            "onUpdate:modelValue": ($event: any) => (options.option = $event)
                                          }, null, 10, ["placeholder", "onUpdate:modelValue"]), [
                                            [_vModelText, options.option]
                                          ])
                                        ])
                                      ])),
                                  _createVNode("div", _hoisted_127, [
                                    _createVNode("button", {
                                      type: "button",
                                      class: "option-btn",
                                      onClick: ($event: any) => (_ctx.deleteSelecedOption(form, options))
                                    }, [
                                      _hoisted_128
                                    ], 8, ["onClick"]),
                                    (form.options && form.options.length)
                                      ? (_openBlock(), _createBlock("span", _hoisted_129, [
                                          (optionsIndex === form.options.length - 1)
                                            ? (_openBlock(), _createBlock("button", {
                                                key: 0,
                                                type: "button",
                                                class: "add-btn",
                                                onClick: ($event: any) => (_ctx.addSelectOptions(form))
                                              }, [
                                                _hoisted_130
                                              ], 8, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128)),
                              _hoisted_131,
                              _createVNode("div", _hoisted_132, [
                                _createVNode("div", _hoisted_133, [
                                  _withDirectives(_createVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: `customSwitch${formIndex}`,
                                    "onUpdate:modelValue": ($event: any) => (form.required = $event)
                                  }, null, 8, ["id", "onUpdate:modelValue"]), [
                                    [_vModelCheckbox, form.required]
                                  ]),
                                  _createVNode("label", {
                                    class: "custom-control-label",
                                    for: `customSwitch${formIndex}`
                                  }, "Required", 8, ["for"])
                                ]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.duplicateSelectedElement(form))
                                }, [
                                  _hoisted_134,
                                  _hoisted_135
                                ], 8, ["onClick"]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.deleteSelectedElement(form))
                                }, [
                                  _hoisted_136,
                                  _hoisted_137
                                ], 8, ["onClick"]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.addElementNew(form))
                                }, [
                                  _hoisted_138,
                                  _hoisted_139
                                ], 8, ["onClick"])
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: "readonly radio-design",
                              onClick: ($event: any) => (_ctx.changeActiveStatus(form))
                            }, [
                              (form.title)
                                ? (_openBlock(), _createBlock("label", _hoisted_140, _toDisplayString(form.title), 1))
                                : (_openBlock(), _createBlock("label", _hoisted_141, "Question")),
                              _createVNode("div", _hoisted_142, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.options, (options, optionsIndex) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "list-items-row",
                                    key: optionsIndex
                                  }, [
                                    _withDirectives(_createVNode("input", {
                                      type: "radio",
                                      id: "",
                                      name: "radioo",
                                      value: options.option,
                                      "onUpdate:modelValue": ($event: any) => (options.selected = $event)
                                    }, null, 8, ["value", "onUpdate:modelValue"]), [
                                      [_vModelRadio, options.selected]
                                    ]),
                                    _createVNode("label", _hoisted_143, _toDisplayString(options.option), 1)
                                  ]))
                                }), 128))
                              ])
                            ], 8, ["onClick"]))
                      ]))
                    : _createCommentVNode("", true),
                  (form.type === 'single_select')
                    ? (_openBlock(), _createBlock("div", _hoisted_144, [
                        (form.isActive)
                          ? (_openBlock(), _createBlock("div", _hoisted_145, [
                              (form.metaDataList && form.metaDataList.length)
                                ? (_openBlock(), _createBlock("div", _hoisted_146, [
                                    _createVNode("div", _hoisted_147, [
                                      _createVNode("div", _hoisted_148, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_149, [
                                      _createVNode("div", _hoisted_150, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.metaData = $event),
                                          onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.selectMetaData && _ctx.selectMetaData(...args)))
                                        }, [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.metaDataList, (metaData, metaDataIndex) => {
                                            return (_openBlock(), _createBlock("option", {
                                              value: metaData,
                                              key: metaDataIndex
                                            }, _toDisplayString(metaData), 9, ["value"]))
                                          }), 128))
                                        ], 40, ["onUpdate:modelValue"]), [
                                          [_vModelSelect, form.metaData]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_151, [
                                      _createVNode("div", _hoisted_152, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_153
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_160, [
                                    _createVNode("div", _hoisted_161, [
                                      _createVNode("div", _hoisted_162, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_163, [
                                      _createVNode("div", _hoisted_164, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_165
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ])),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.options, (options, optionsIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "row checkbox",
                                  key: optionsIndex
                                }, [
                                  _createVNode("div", _hoisted_172, [
                                    _createVNode("div", _hoisted_173, [
                                      _withDirectives(_createVNode("input", {
                                        type: "radio",
                                        id: "selectOption1",
                                        name: "selectOption",
                                        "onUpdate:modelValue": ($event: any) => (options.selected = $event),
                                        value: options.option
                                      }, null, 8, ["onUpdate:modelValue", "value"]), [
                                        [_vModelRadio, options.selected]
                                      ])
                                    ])
                                  ]),
                                  (form.metaDataList && form.metaDataList.length)
                                    ? (_openBlock(), _createBlock("div", _hoisted_174, [
                                        _createVNode("div", _hoisted_175, [
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            class: 
                          options.optionError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                            placeholder: `Option ${optionsIndex + 1}`,
                                            "onUpdate:modelValue": ($event: any) => (options.option = $event)
                                          }, null, 10, ["placeholder", "onUpdate:modelValue"]), [
                                            [_vModelText, options.option]
                                          ])
                                        ])
                                      ]))
                                    : (_openBlock(), _createBlock("div", _hoisted_176, [
                                        _createVNode("div", _hoisted_177, [
                                          _withDirectives(_createVNode("input", {
                                            type: "text",
                                            class: 
                          options.optionError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                            placeholder: `Option ${optionsIndex + 1}`,
                                            "onUpdate:modelValue": ($event: any) => (options.option = $event)
                                          }, null, 10, ["placeholder", "onUpdate:modelValue"]), [
                                            [_vModelText, options.option]
                                          ])
                                        ])
                                      ])),
                                  _createVNode("div", _hoisted_178, [
                                    _createVNode("button", {
                                      type: "button",
                                      class: "option-btn",
                                      onClick: ($event: any) => (_ctx.deleteSelecedOption(form, options))
                                    }, [
                                      _hoisted_179
                                    ], 8, ["onClick"]),
                                    (form.options && form.options.length)
                                      ? (_openBlock(), _createBlock("span", _hoisted_180, [
                                          (optionsIndex === form.options.length - 1)
                                            ? (_openBlock(), _createBlock("button", {
                                                key: 0,
                                                type: "button",
                                                class: "add-btn",
                                                onClick: ($event: any) => (_ctx.addSelectOptions(form))
                                              }, [
                                                _hoisted_181
                                              ], 8, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128)),
                              _hoisted_182,
                              _createVNode("div", _hoisted_183, [
                                _createVNode("div", _hoisted_184, [
                                  _withDirectives(_createVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: `customSwitch${formIndex}`,
                                    "onUpdate:modelValue": ($event: any) => (form.required = $event)
                                  }, null, 8, ["id", "onUpdate:modelValue"]), [
                                    [_vModelCheckbox, form.required]
                                  ]),
                                  _createVNode("label", {
                                    class: "custom-control-label",
                                    for: `customSwitch${formIndex}`
                                  }, "Required", 8, ["for"])
                                ]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.duplicateSelectedElement(form))
                                }, [
                                  _hoisted_185,
                                  _hoisted_186
                                ], 8, ["onClick"]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.deleteSelectedElement(form))
                                }, [
                                  _hoisted_187,
                                  _hoisted_188
                                ], 8, ["onClick"]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.addElementNew(form))
                                }, [
                                  _hoisted_189,
                                  _hoisted_190
                                ], 8, ["onClick"])
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: "readonly select-design",
                              onClick: ($event: any) => (_ctx.changeActiveStatus(form))
                            }, [
                              (form.title)
                                ? (_openBlock(), _createBlock("label", _hoisted_191, _toDisplayString(form.title), 1))
                                : (_openBlock(), _createBlock("label", _hoisted_192, "Question")),
                              _createVNode("div", _hoisted_193, [
                                _createVNode("ul", null, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.options, (options, optionsIndex) => {
                                    return (_openBlock(), _createBlock("li", { key: optionsIndex }, _toDisplayString(options.option), 1))
                                  }), 128))
                                ])
                              ])
                            ], 8, ["onClick"]))
                      ]))
                    : _createCommentVNode("", true),
                  (form.type === 'textArea')
                    ? (_openBlock(), _createBlock("div", _hoisted_194, [
                        (form.isActive)
                          ? (_openBlock(), _createBlock("div", _hoisted_195, [
                              (form.metaDataList && form.metaDataList.length)
                                ? (_openBlock(), _createBlock("div", _hoisted_196, [
                                    _createVNode("div", _hoisted_197, [
                                      _createVNode("div", _hoisted_198, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_199, [
                                      _createVNode("div", _hoisted_200, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.metaData = $event),
                                          onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.selectMetaData && _ctx.selectMetaData(...args)))
                                        }, [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.metaDataList, (metaData, metaDataIndex) => {
                                            return (_openBlock(), _createBlock("option", {
                                              value: metaData,
                                              key: metaDataIndex
                                            }, _toDisplayString(metaData), 9, ["value"]))
                                          }), 128))
                                        ], 40, ["onUpdate:modelValue"]), [
                                          [_vModelSelect, form.metaData]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_201, [
                                      _createVNode("div", _hoisted_202, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_203
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_210, [
                                    _createVNode("div", _hoisted_211, [
                                      _createVNode("div", _hoisted_212, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_213, [
                                      _createVNode("div", _hoisted_214, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_215
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ])),
                              _createVNode("div", _hoisted_222, [
                                _withDirectives(_createVNode("input", {
                                  disabled: "",
                                  type: "text",
                                  class: "form-control",
                                  placeholder: "Answer",
                                  "onUpdate:modelValue": ($event: any) => (form.answer = $event)
                                }, null, 8, ["onUpdate:modelValue"]), [
                                  [_vModelText, form.answer]
                                ])
                              ]),
                              _hoisted_223,
                              _createVNode("div", _hoisted_224, [
                                _createVNode("div", _hoisted_225, [
                                  _withDirectives(_createVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: `customSwitch${formIndex}`,
                                    "onUpdate:modelValue": ($event: any) => (form.required = $event)
                                  }, null, 8, ["id", "onUpdate:modelValue"]), [
                                    [_vModelCheckbox, form.required]
                                  ]),
                                  _createVNode("label", {
                                    class: "custom-control-label",
                                    for: `customSwitch${formIndex}`
                                  }, "Required", 8, ["for"])
                                ]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.duplicateSelectedElement(form))
                                }, [
                                  _hoisted_226,
                                  _hoisted_227
                                ], 8, ["onClick"]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.deleteSelectedElement(form))
                                }, [
                                  _hoisted_228,
                                  _hoisted_229
                                ], 8, ["onClick"]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.addElementNew(form))
                                }, [
                                  _hoisted_230,
                                  _hoisted_231
                                ], 8, ["onClick"])
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: "readonly text-design",
                              onClick: ($event: any) => (_ctx.changeActiveStatus(form))
                            }, [
                              (form.title)
                                ? (_openBlock(), _createBlock("label", _hoisted_232, _toDisplayString(form.title), 1))
                                : (_openBlock(), _createBlock("label", _hoisted_233, "Question")),
                              (form.answer)
                                ? (_openBlock(), _createBlock("p", _hoisted_234, _toDisplayString(form.answer), 1))
                                : _withDirectives((_openBlock(), _createBlock("input", {
                                    key: 3,
                                    disabled: "",
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "Answer",
                                    "onUpdate:modelValue": ($event: any) => (form.answer = $event)
                                  }, null, 8, ["onUpdate:modelValue"])), [
                                    [_vModelText, form.answer]
                                  ])
                            ], 8, ["onClick"]))
                      ]))
                    : _createCommentVNode("", true),
                  (form.type === 'textbox')
                    ? (_openBlock(), _createBlock("div", _hoisted_235, [
                        (form.isActive)
                          ? (_openBlock(), _createBlock("div", _hoisted_236, [
                              (form.metaDataList && form.metaDataList.length)
                                ? (_openBlock(), _createBlock("div", _hoisted_237, [
                                    _createVNode("div", _hoisted_238, [
                                      _createVNode("div", _hoisted_239, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    (form.metaDataList && form.metaDataList.length)
                                      ? (_openBlock(), _createBlock("div", _hoisted_240, [
                                          _createVNode("div", _hoisted_241, [
                                            _withDirectives(_createVNode("select", {
                                              class: "form-control custom-select",
                                              "onUpdate:modelValue": ($event: any) => (form.metaData = $event)
                                            }, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.metaDataList, (metaData, metaDataIndex) => {
                                                return (_openBlock(), _createBlock("option", {
                                                  value: metaData,
                                                  key: metaDataIndex
                                                }, _toDisplayString(metaData), 9, ["value"]))
                                              }), 128))
                                            ], 8, ["onUpdate:modelValue"]), [
                                              [_vModelSelect, form.metaData]
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode("div", _hoisted_242, [
                                      _createVNode("div", _hoisted_243, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_244
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_251, [
                                    _createVNode("div", _hoisted_252, [
                                      _createVNode("div", _hoisted_253, [
                                        _withDirectives(_createVNode("input", {
                                          id: "inputTextBoxTitle",
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_254, [
                                      _createVNode("div", _hoisted_255, [
                                        _withDirectives(_createVNode("select", {
                                          id: "selectTextBox",
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_256
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ])),
                              _createVNode("div", _hoisted_263, [
                                _withDirectives(_createVNode("input", {
                                  id: "answerTextBox",
                                  disabled: "",
                                  type: "text",
                                  class: "form-control",
                                  placeholder: "Answer",
                                  "onUpdate:modelValue": ($event: any) => (form.answer = $event)
                                }, null, 8, ["onUpdate:modelValue"]), [
                                  [_vModelText, form.answer]
                                ])
                              ]),
                              _hoisted_264,
                              _createVNode("div", _hoisted_265, [
                                _createVNode("div", _hoisted_266, [
                                  _withDirectives(_createVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: `customSwitch${formIndex}`,
                                    "onUpdate:modelValue": ($event: any) => (form.required = $event)
                                  }, null, 8, ["id", "onUpdate:modelValue"]), [
                                    [_vModelCheckbox, form.required]
                                  ]),
                                  _createVNode("label", {
                                    class: "custom-control-label",
                                    for: `customSwitch${formIndex}`
                                  }, "Required", 8, ["for"])
                                ]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.duplicateSelectedElement(form))
                                }, [
                                  _hoisted_267,
                                  _hoisted_268
                                ], 8, ["onClick"]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.deleteSelectedElement(form))
                                }, [
                                  _hoisted_269,
                                  _hoisted_270
                                ], 8, ["onClick"]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.addElementNew(form))
                                }, [
                                  _hoisted_271,
                                  _hoisted_272
                                ], 8, ["onClick"])
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: "readonly text-design",
                              onClick: ($event: any) => (_ctx.changeActiveStatus(form))
                            }, [
                              (form.title)
                                ? (_openBlock(), _createBlock("label", _hoisted_273, _toDisplayString(form.title), 1))
                                : (_openBlock(), _createBlock("label", _hoisted_274, "Question")),
                              (form.answer)
                                ? (_openBlock(), _createBlock("p", _hoisted_275, _toDisplayString(form.answer), 1))
                                : _withDirectives((_openBlock(), _createBlock("input", {
                                    key: 3,
                                    disabled: "",
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "Answer",
                                    "onUpdate:modelValue": ($event: any) => (form.answer = $event)
                                  }, null, 8, ["onUpdate:modelValue"])), [
                                    [_vModelText, form.answer]
                                  ])
                            ], 8, ["onClick"]))
                      ]))
                    : _createCommentVNode("", true),
                  (form.type === 'digitalSignature')
                    ? (_openBlock(), _createBlock("div", _hoisted_276, [
                        (form.isActive)
                          ? (_openBlock(), _createBlock("div", _hoisted_277, [
                              (form.metaDataList && form.metaDataList.length)
                                ? (_openBlock(), _createBlock("div", _hoisted_278, [
                                    _createVNode("div", _hoisted_279, [
                                      _createVNode("div", _hoisted_280, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_281, [
                                      _createVNode("div", _hoisted_282, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.metaData = $event)
                                        }, [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.metaDataList, (metaData, metaDataIndex) => {
                                            return (_openBlock(), _createBlock("option", {
                                              value: metaData,
                                              key: metaDataIndex
                                            }, _toDisplayString(metaData), 9, ["value"]))
                                          }), 128))
                                        ], 8, ["onUpdate:modelValue"]), [
                                          [_vModelSelect, form.metaData]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_283, [
                                      _createVNode("div", _hoisted_284, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_285
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_292, [
                                    _createVNode("div", _hoisted_293, [
                                      _createVNode("div", _hoisted_294, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_295, [
                                      _createVNode("div", _hoisted_296, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_297
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ])),
                              _createVNode("div", _hoisted_304, [
                                _createVNode("div", _hoisted_305, [
                                  _createVNode("div", _hoisted_306, [
                                    _createVNode("canvas", {
                                      id: `myCanvas${formIndex}`
                                    }, null, 8, ["id"])
                                  ]),
                                  _createVNode("button", {
                                    onClick: ($event: any) => (_ctx.clearSelectedSignature(form)),
                                    class: "btn default-btn mt-3"
                                  }, " clear ", 8, ["onClick"])
                                ])
                              ]),
                              _hoisted_307,
                              _createVNode("div", _hoisted_308, [
                                _createVNode("div", _hoisted_309, [
                                  _withDirectives(_createVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: `customSwitch${formIndex}`,
                                    "onUpdate:modelValue": ($event: any) => (form.required = $event)
                                  }, null, 8, ["id", "onUpdate:modelValue"]), [
                                    [_vModelCheckbox, form.required]
                                  ]),
                                  _createVNode("label", {
                                    class: "custom-control-label",
                                    for: `customSwitch${formIndex}`
                                  }, "Required", 8, ["for"])
                                ]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.duplicateSelectedElement(form))
                                }, [
                                  _hoisted_310,
                                  _hoisted_311
                                ], 8, ["onClick"]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.deleteSelectedElement(form))
                                }, [
                                  _hoisted_312,
                                  _hoisted_313
                                ], 8, ["onClick"]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.addElementNew(form))
                                }, [
                                  _hoisted_314,
                                  _hoisted_315
                                ], 8, ["onClick"])
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: "readonly text-design",
                              onClick: ($event: any) => (_ctx.changeActiveStatus(form))
                            }, [
                              (form.title)
                                ? (_openBlock(), _createBlock("label", _hoisted_316, _toDisplayString(form.title), 1))
                                : (_openBlock(), _createBlock("label", _hoisted_317, "Question")),
                              (form.answer)
                                ? (_openBlock(), _createBlock("p", _hoisted_318, _toDisplayString(form.answer), 1))
                                : _withDirectives((_openBlock(), _createBlock("input", {
                                    key: 3,
                                    disabled: "",
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "Answer",
                                    "onUpdate:modelValue": ($event: any) => (form.answer = $event)
                                  }, null, 8, ["onUpdate:modelValue"])), [
                                    [_vModelText, form.answer]
                                  ])
                            ], 8, ["onClick"]))
                      ]))
                    : _createCommentVNode("", true),
                  (form.type === 'datePicker')
                    ? (_openBlock(), _createBlock("div", _hoisted_319, [
                        (form.isActive)
                          ? (_openBlock(), _createBlock("div", _hoisted_320, [
                              (form.metaDataList && form.metaDataList.length)
                                ? (_openBlock(), _createBlock("div", _hoisted_321, [
                                    _createVNode("div", _hoisted_322, [
                                      _createVNode("div", _hoisted_323, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    (form.metaDataList && form.metaDataList.length)
                                      ? (_openBlock(), _createBlock("div", _hoisted_324, [
                                          _createVNode("div", _hoisted_325, [
                                            _withDirectives(_createVNode("select", {
                                              class: "form-control custom-select",
                                              "onUpdate:modelValue": ($event: any) => (form.metaData = $event)
                                            }, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.metaDataList, (metaData, metaDataIndex) => {
                                                return (_openBlock(), _createBlock("option", {
                                                  value: metaData,
                                                  key: metaDataIndex
                                                }, _toDisplayString(metaData), 9, ["value"]))
                                              }), 128))
                                            ], 8, ["onUpdate:modelValue"]), [
                                              [_vModelSelect, form.metaData]
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode("div", _hoisted_326, [
                                      _createVNode("div", _hoisted_327, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_328
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_335, [
                                    _createVNode("div", _hoisted_336, [
                                      _createVNode("div", _hoisted_337, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: 
                          form.titleError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                                          placeholder: "Question",
                                          "onUpdate:modelValue": ($event: any) => (form.title = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, form.title]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_338, [
                                      _createVNode("div", _hoisted_339, [
                                        _withDirectives(_createVNode("select", {
                                          class: "form-control custom-select",
                                          "onUpdate:modelValue": ($event: any) => (form.type = $event),
                                          onChange: ($event: any) => (_ctx.selectedFormElement(form))
                                        }, [
                                          _hoisted_340
                                        ], 40, ["onUpdate:modelValue", "onChange"]), [
                                          [_vModelSelect, form.type]
                                        ])
                                      ])
                                    ])
                                  ])),
                              _createVNode("div", _hoisted_347, [
                                _createVNode("div", _hoisted_348, [
                                  _createVNode("div", _hoisted_349, [
                                    _hoisted_350,
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Please choose the date",
                                      "onUpdate:modelValue": ($event: any) => (form.date = $event),
                                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showHideCalender && _ctx.showHideCalender(...args))),
                                      onkeydown: "return false;"
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, form.date]
                                    ])
                                  ]),
                                  (_ctx.state.data.isCalenderHide)
                                    ? (_openBlock(), _createBlock(_component_v_date_picker, {
                                        key: 0,
                                        modelValue: form.date,
                                        "onUpdate:modelValue": ($event: any) => (form.date = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _hoisted_351,
                              _createVNode("div", _hoisted_352, [
                                _createVNode("div", _hoisted_353, [
                                  _withDirectives(_createVNode("input", {
                                    type: "checkbox",
                                    class: "custom-control-input",
                                    id: `customSwitch${formIndex}`,
                                    "onUpdate:modelValue": ($event: any) => (form.required = $event)
                                  }, null, 8, ["id", "onUpdate:modelValue"]), [
                                    [_vModelCheckbox, form.required]
                                  ]),
                                  _createVNode("label", {
                                    class: "custom-control-label",
                                    for: `customSwitch${formIndex}`
                                  }, "Required", 8, ["for"])
                                ]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.duplicateSelectedElement(form))
                                }, [
                                  _hoisted_354,
                                  _hoisted_355
                                ], 8, ["onClick"]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.deleteSelectedElement(form))
                                }, [
                                  _hoisted_356,
                                  _hoisted_357
                                ], 8, ["onClick"]),
                                _createVNode("div", {
                                  class: "action-wrapper",
                                  onClick: ($event: any) => (_ctx.addElementNew(form))
                                }, [
                                  _hoisted_358,
                                  _hoisted_359
                                ], 8, ["onClick"])
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: "readonly text-design",
                              onClick: ($event: any) => (_ctx.changeActiveStatus(form))
                            }, [
                              (form.title)
                                ? (_openBlock(), _createBlock("label", _hoisted_360, _toDisplayString(form.title), 1))
                                : (_openBlock(), _createBlock("label", _hoisted_361, "Question")),
                              _createVNode("div", _hoisted_362, [
                                _hoisted_363,
                                _withDirectives(_createVNode("input", {
                                  disabled: "",
                                  type: "text",
                                  class: "form-control",
                                  placeholder: "Please choose the date",
                                  "onUpdate:modelValue": ($event: any) => (form.date = $event),
                                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showHideCalender && _ctx.showHideCalender(...args))),
                                  onkeydown: "return false;"
                                }, null, 8, ["onUpdate:modelValue"]), [
                                  [_vModelText, form.date]
                                ])
                              ])
                            ], 8, ["onClick"]))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_364, [
        _createVNode("a", {
          id: "checkValiditionOfForm",
          class: "btn default-btn",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.checkValidation && _ctx.checkValidation(...args)))
        }, "Continue")
      ])
    ]),
    _createVNode("div", _hoisted_365, [
      _createVNode("div", _hoisted_366, [
        _createVNode("div", _hoisted_367, [
          _createVNode("div", _hoisted_368, [
            _createVNode("div", _hoisted_369, [
              _createVNode("div", {
                class: "modal-back-btn",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.sendOptionBack && _ctx.sendOptionBack(...args)))
              }, [
                _hoisted_370
              ]),
              _hoisted_371,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.hideSendOptionModal && _ctx.hideSendOptionModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_372
              ])
            ]),
            _createVNode("div", _hoisted_373, [
              _createVNode("div", _hoisted_374, [
                _hoisted_375,
                _withDirectives(_createVNode("select", {
                  class: "custom-select form-control",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.state.data.formType = $event))
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.formTypeList, (item, itemIndex) => {
                    return (_openBlock(), _createBlock("option", {
                      value: item.value,
                      key: itemIndex
                    }, _toDisplayString(item.name), 9, ["value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.state.data.formType]
                ])
              ]),
              _createVNode("div", _hoisted_376, [
                _hoisted_377,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.state.data.tags.value,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.data.tags.value = $event)),
                  mode: "tags",
                  searchable: true,
                  createTag: true,
                  options: _ctx.state.data.tags.options,
                  onTag: _ctx.addTag
                }, null, 8, ["modelValue", "options", "onTag"])
              ]),
              (
                  _ctx.state.data.formType == 'private' &&
                  _ctx.state.data.isSaveShareButton &&
                  _ctx.state.data.formMode != 'send'
                )
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: "send-option-list-item",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.saveDataAndShare && _ctx.saveDataAndShare(...args)))
                  }, [
                    _hoisted_378,
                    _hoisted_379,
                    _hoisted_380,
                    _hoisted_381
                  ]))
                : _createCommentVNode("", true),
              (
                  _ctx.state.data.formType == 'share' ||
                  _ctx.state.data.saveShaer ||
                  _ctx.state.data.formMode == 'send'
                )
                ? (_openBlock(), _createBlock("div", _hoisted_382, [
                    _createVNode("div", _hoisted_383, [
                      _hoisted_384,
                      _withDirectives(_createVNode("select", {
                        disabled: 
                      !_ctx.state.data.projectList || !_ctx.state.data.projectList.length
                    ,
                        class: "custom-select form-control",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.data.selectedChannelByProject.project = $event)),
                        onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.getChannelByProjectChange && _ctx.getChannelByProjectChange(...args)))
                      }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectList, (item, itemIndex) => {
                          return (_openBlock(), _createBlock("option", {
                            value: item,
                            key: itemIndex
                          }, _toDisplayString(item.name), 9, ["value"]))
                        }), 128))
                      ], 40, ["disabled"]), [
                        [_vModelSelect, _ctx.state.data.selectedChannelByProject.project]
                      ])
                    ]),
                    _createVNode("div", _hoisted_385, [
                      (_ctx.state.data.selectedChannelByProject.project)
                        ? (_openBlock(), _createBlock("div", _hoisted_386))
                        : _createCommentVNode("", true),
                      (
                      _ctx.state.data.channelList && _ctx.state.data.channelList.length
                    )
                        ? (_openBlock(), _createBlock("label", _hoisted_387, "Select channel"))
                        : _createCommentVNode("", true),
                      (
                      _ctx.state.data.channelList && _ctx.state.data.channelList.length
                    )
                        ? _withDirectives((_openBlock(), _createBlock("select", {
                            key: 2,
                            disabled: 
                      !_ctx.state.data.channelList && !_ctx.state.data.channelList.length
                    ,
                            class: "custom-select form-control",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.state.data.selectedChannelByProject.channel = $event)),
                            onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.getUserList && _ctx.getUserList(...args)))
                          }, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.channelList, (channel, channelIndex) => {
                              return (_openBlock(), _createBlock("option", {
                                value: channel,
                                key: channelIndex
                              }, _toDisplayString(channel.name), 9, ["value"]))
                            }), 128))
                          ], 40, ["disabled"])), [
                            [_vModelSelect, _ctx.state.data.selectedChannelByProject.channel]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_388, [
                      _hoisted_389,
                      _withDirectives(_createVNode("select", {
                        class: "form-control mb-2",
                        id: "",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.state.existingMember = $event)),
                        onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.changeExistingMemberInForm && _ctx.changeExistingMemberInForm(...args)))
                      }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.userList, (item, itemIndex) => {
                          return (_openBlock(), _createBlock("option", {
                            value: item,
                            key: itemIndex
                          }, _toDisplayString(item.full_name) + " (" + _toDisplayString(item.email) + ") ", 9, ["value"]))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.state.existingMember]
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "email-tag",
                          key: userIndex
                        }, [
                          _createVNode("p", _hoisted_390, [
                            _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                            }, [
                              _hoisted_391
                            ], 8, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createVNode("div", _hoisted_392, [
                      _hoisted_393,
                      _withDirectives(_createVNode("textarea", {
                        class: "form-control",
                        id: "w3review",
                        name: "w3review",
                        rows: "4",
                        cols: "50",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.state.data.additionalMessage = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.data.additionalMessage]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
                  !_ctx.state.data.sendToUserStatus && !_ctx.state.data.showSelectProject
                )
                ? (_openBlock(), _createBlock("div", _hoisted_394, [
                    (_ctx.state.data.showSaveMsg)
                      ? (_openBlock(), _createBlock("div", _hoisted_395, [
                          (
                      _ctx.state.data.selectedChannelByProject.project &&
                      _ctx.state.data.selectedChannelByProject.project.name &&
                      _ctx.state.data.selectedChannelByProject.channel &&
                      _ctx.state.data.selectedChannelByProject.channel.name
                    )
                            ? (_openBlock(), _createBlock("p", _hoisted_396, " This form will be save in " + _toDisplayString(_ctx.state.data.selectedChannelByProject.project.name) + " in channel : " + _toDisplayString(_ctx.state.data.selectedChannelByProject.channel.name) + " for future use. ", 1))
                            : _createCommentVNode("", true),
                          (
                      _ctx.state.data.selectedChannelByProject.project &&
                      _ctx.state.data.selectedChannelByProject.project.name &&
                      _ctx.state.data.selectedChannelByProject.channel &&
                      !_ctx.state.data.selectedChannelByProject.channel.uuid
                    )
                            ? (_openBlock(), _createBlock("p", _hoisted_397, " This form will be save in " + _toDisplayString(_ctx.state.data.selectedChannelByProject.project.name) + " for future use. ", 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_398, [
              _createVNode("div", _hoisted_399, [
                (_ctx.state.data.formType == 'share' || _ctx.state.data.saveShaer)
                  ? (_openBlock(), _createBlock("div", _hoisted_400, [
                      _createVNode("div", _hoisted_401, [
                        _hoisted_402,
                        (
                        _ctx.state.data.privacyList && _ctx.state.data.privacyList.length
                      )
                          ? (_openBlock(), _createBlock("div", _hoisted_403, [
                              _withDirectives(_createVNode("select", {
                                disabled: 
                          _ctx.state.data.selectedChannelByProject.project &&
                          _ctx.state.data.selectedChannelByProject.project.name &&
                          _ctx.state.data.selectedChannelByProject.channel &&
                          !_ctx.state.data.selectedChannelByProject.channel.name
                        ,
                                class: "custom-select form-control",
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.state.data.privacy = $event))
                              }, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.privacyList, (item, itemIndex) => {
                                  return (_openBlock(), _createBlock("option", {
                                    value: item,
                                    key: itemIndex
                                  }, _toDisplayString(item.name), 9, ["value"]))
                                }), 128))
                              ], 8, ["disabled"]), [
                                [_vModelSelect, _ctx.state.data.privacy]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_404, [
                          _hoisted_405,
                          _createVNode("div", _hoisted_406, [
                            _createVNode("h5", null, _toDisplayString(_ctx.state.data.privacy.value), 1),
                            _createVNode("p", _hoisted_407, _toDisplayString(_ctx.formPrivacyMessage), 1)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_408, [
                  _createVNode("div", _hoisted_409, [
                    (
                        _ctx.state.data.formType == 'share' ||
                        _ctx.state.data.formMode === 'send'
                      )
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn default-btn",
                          onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.validateChannelAndUser && _ctx.validateChannelAndUser(...args)))
                        }, " Send "))
                      : _createCommentVNode("", true),
                    (
                        (_ctx.state.data.formType == 'public' &&
                          _ctx.state.data.formMode != 'send') ||
                        (_ctx.state.data.formType == 'private' &&
                          _ctx.state.data.formMode != 'send')
                      )
                      ? (_openBlock(), _createBlock("button", {
                          key: 1,
                          type: "button",
                          class: "btn default-btn",
                          onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.validateChannelAndUser && _ctx.validateChannelAndUser(...args)))
                        }, " Save "))
                      : _createCommentVNode("", true),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.hideSendOptionModal && _ctx.hideSendOptionModal(...args)))
                    }, " Cancel ")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_410, [
      _createVNode("div", _hoisted_411, [
        _createVNode("div", _hoisted_412, [
          _createVNode("div", _hoisted_413, [
            _hoisted_414,
            _createVNode("div", _hoisted_415, [
              _createVNode("div", _hoisted_416, [
                _createVNode("div", _hoisted_417, [
                  _hoisted_418,
                  _withDirectives(_createVNode("select", {
                    disabled: 
                      !_ctx.state.data.projectList && !_ctx.state.data.projectList.length
                    ,
                    class: "custom-select form-control",
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.state.data.selectedChannelByProject.project = $event))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectList, (item, itemIndex) => {
                      return (_openBlock(), _createBlock("option", {
                        value: item,
                        key: itemIndex
                      }, _toDisplayString(item.name), 9, ["value"]))
                    }), 128))
                  ], 8, ["disabled"]), [
                    [_vModelSelect, _ctx.state.data.selectedChannelByProject.project]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_419, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.hideProjectSelectModal && _ctx.hideProjectSelectModal(...args)))
              }, " Let's create form "),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.hideProjectSelectModal && _ctx.hideProjectSelectModal(...args)))
              }, " Cancel ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_420, [
      _createVNode("div", _hoisted_421, [
        _createVNode("div", _hoisted_422, [
          _createVNode("div", _hoisted_423, [
            _createVNode("div", _hoisted_424, [
              _hoisted_425,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.hideCreateForm && _ctx.hideCreateForm(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_426
              ])
            ]),
            _createVNode("div", _hoisted_427, [
              _createVNode("div", _hoisted_428, [
                _createVNode("div", _hoisted_429, [
                  _hoisted_430,
                  (_ctx.state.newFormData.title)
                    ? (_openBlock(), _createBlock("h3", _hoisted_431, _toDisplayString(_ctx.state.newFormData.title), 1))
                    : _createCommentVNode("", true),
                  (_ctx.state.newFormData.description)
                    ? (_openBlock(), _createBlock("h5", _hoisted_432, _toDisplayString(_ctx.state.newFormData.description), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_433, [
                  _createVNode("form", null, [
                    (
                        _ctx.state.data.elementList && _ctx.state.data.elementList.length
                      )
                      ? (_openBlock(), _createBlock("fieldset", _hoisted_434, [
                          _createVNode("div", _hoisted_435, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                            .elementList, (element, elementIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "form-group",
                                key: elementIndex
                              }, [
                                (element.type === 'title')
                                  ? (_openBlock(), _createBlock(_component_TitleComponent, {
                                      key: 0,
                                      title: element.title,
                                      description: element.description,
                                      editStatus: false
                                    }, null, 8, ["title", "description"]))
                                  : _createCommentVNode("", true),
                                (element.type === 'textbox')
                                  ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                                      key: 1,
                                      data: element,
                                      editStatus: false
                                    }, null, 8, ["data"]))
                                  : _createCommentVNode("", true),
                                (element.type === 'radioButton')
                                  ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                                      key: 2,
                                      data: element,
                                      editStatus: false
                                    }, null, 8, ["data"]))
                                  : _createCommentVNode("", true),
                                (element.type === 'single_select')
                                  ? (_openBlock(), _createBlock(_component_SelectOption, {
                                      key: 3,
                                      data: element,
                                      editStatus: false
                                    }, null, 8, ["data"]))
                                  : _createCommentVNode("", true),
                                (element.type === 'checkBox')
                                  ? (_openBlock(), _createBlock(_component_CheckBox, {
                                      key: 4,
                                      data: element,
                                      editStatus: false
                                    }, null, 8, ["data"]))
                                  : _createCommentVNode("", true),
                                (element.type === 'textArea')
                                  ? (_openBlock(), _createBlock(_component_TextArea, {
                                      key: 5,
                                      data: element,
                                      editStatus: false
                                    }, null, 8, ["data"]))
                                  : _createCommentVNode("", true),
                                (element.type === 'datePicker')
                                  ? (_openBlock(), _createBlock("div", _hoisted_436, [
                                      (element.title)
                                        ? (_openBlock(), _createBlock("label", _hoisted_437, _toDisplayString(element.title), 1))
                                        : _createCommentVNode("", true),
                                      _createVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        value: element.date
                                      }, null, 8, ["value"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (element.type === 'digitalSignature')
                                  ? (_openBlock(), _createBlock("div", _hoisted_438, [
                                      _createVNode("div", _hoisted_439, [
                                        _createVNode("div", _hoisted_440, [
                                          _hoisted_441,
                                          (element.title)
                                            ? (_openBlock(), _createBlock("label", _hoisted_442, _toDisplayString(element.title), 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_443, [
      _createVNode("div", _hoisted_444, [
        _createVNode("div", _hoisted_445, [
          _createVNode("div", _hoisted_446, [
            _createVNode("div", _hoisted_447, [
              _hoisted_448,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
              }, [
                _hoisted_449
              ])
            ]),
            _createVNode("div", _hoisted_450, [
              (_ctx.state.ui.isPostLoading.getEdocsList)
                ? (_openBlock(), _createBlock("div", _hoisted_451, [
                    _hoisted_452,
                    _hoisted_453
                  ]))
                : _createCommentVNode("", true),
              (
                  _ctx.state.data.edocsList.docs && _ctx.state.data.edocsList.docs.length
                )
                ? (_openBlock(), _createBlock("div", _hoisted_454, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.edocsList.docs, (doc, docIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-lg-3 col-sm-6",
                        key: docIndex
                      }, [
                        _createVNode("div", _hoisted_455, [
                          _createVNode("p", null, _toDisplayString(doc.title), 1),
                          _createVNode("div", _hoisted_456, [
                            _createVNode("div", _hoisted_457, [
                              _createVNode("div", _hoisted_458, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "btn btn-primary btn-sm mr-1",
                                  onClick: ($event: any) => (_ctx.selectEdoc(doc))
                                }, _toDisplayString(_ctx.state.ui.isPostLoading.selectEdoc
                                ? "Loading..."
                                : "Select"), 9, ["onClick"]),
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "btn btn-light btn-sm",
                                  onClick: ($event: any) => (_ctx.previewEdoc(doc))
                                }, "Preview", 8, ["onClick"])
                              ])
                            ]),
                            (doc.galleryThumbUrl)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: doc.galleryThumbUrl
                                }, null, 8, ["src"]))
                              : (_openBlock(), _createBlock("img", _hoisted_459))
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_460, [
                    _createVNode(_component_EmptyData, {
                      title: _ctx.state.title,
                      heading: _ctx.state.heading
                    }, null, 8, ["title", "heading"])
                  ]))
            ]),
            _createVNode("div", _hoisted_461, [
              _createVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-dismiss": "modal",
                onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
              }, " Close ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_462, [
      _createVNode("div", _hoisted_463, [
        _createVNode("div", _hoisted_464, [
          _createVNode("div", _hoisted_465, [
            _hoisted_466,
            _hoisted_467,
            _createVNode("div", _hoisted_468, [
              _createVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.closeSuccessfulModal && _ctx.closeSuccessfulModal(...args)))
              }, " Close ")
            ])
          ])
        ])
      ])
    ])
  ]))
})